import React from "react";
import { calcPrice } from "../product/helper";
import { ConfirmResultProps } from "../orders";
import {
  withRecordOrderSentInBrowser,
  withRecordOrderSentInBrowserProps,
} from "../withRecordOrderSentInBrowser";

declare global {
  interface Window {
    snapboard_params: {
      item_maker_code: string;
    };
    snapboard_itemData: {
      order_id: string;
      item: Array<{
        id?: string | null;
        price: number;
        quantity: number;
      }>;
    };
  }
}

const SnapboardTargetForPDP = () => {
  return (
    <div className="snap_pdp">
      <div id="__nuxt"></div>
    </div>
  );
};

const SnapboardTargetForThankYou = withRecordOrderSentInBrowser(
  ({
    confirmResult: { result },
    orderFirstSent,
  }: ConfirmResultProps & withRecordOrderSentInBrowserProps) => {
    const uploadData = React.useCallback(() => {
      if (result) {
        const { order } = result;
        if (order) {
          const orderCode = order.code || "";
          const orderItems = order.orderItems || [];

          const item: Array<{
            id?: string | null;
            price: number;
            quantity: number;
          }> = [];

          orderItems.forEach((orderItem) => {
            const { price, discounted } = calcPrice(orderItem);
            item.push({
              id: orderItem.productCode,
              price: discounted || price,
              quantity: Number(orderItem.quantity || 0),
            });
          });

          window.snapboard_itemData = window.snapboard_itemData || {};
          window.snapboard_itemData = {
            order_id: orderCode,
            item: item,
          };

          if (!document.getElementById("sb-conversion-tracker")) {
            const scriptDiv = document.createElement("script");

            scriptDiv.setAttribute("id", "sb-conversion-tracker");
            scriptDiv.src = "https://admin.snapboard.jp/js/ec_conversions.js";
            scriptDiv.async = true;
            document.body.appendChild(scriptDiv);
          }
        }
      }
    }, [result]);

    React.useEffect(() => {
      const orderCode = result?.order?.code;
      if (orderCode && orderFirstSent && orderFirstSent(orderCode)) {
        uploadData();
      }
    }, [result, orderFirstSent, uploadData]);

    return null;
  }
);

export { SnapboardTargetForPDP, SnapboardTargetForThankYou };
